var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClosePopup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_24250)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3863 44.3872C54.5404 34.233 54.5404 17.7699 44.3863 7.61571C34.2321 -2.53846 17.7689 -2.53846 7.61476 7.61571C-2.53941 17.7699 -2.53941 34.233 7.61476 44.3872C17.7689 54.5414 34.2321 54.5414 44.3863 44.3872Z",
    fill: "url(#paint0_linear_13_24250)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5578 42.5586C51.702 33.4144 51.702 18.5886 42.5578 9.44429C33.4135 0.300011 18.5877 0.300012 9.44341 9.44429C0.29913 18.5886 0.29913 33.4144 9.44341 42.5586C18.5877 51.7029 33.4135 51.7029 42.5578 42.5586Z",
    fill: "url(#paint1_linear_13_24250)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0014 0.964554C40.2008 0.964554 51.7395 12.3452 51.9945 26.4837C51.9972 26.3229 52 26.1621 52 26.0014C52 11.6412 40.3588 0 26.0014 0C11.6439 0 0 11.6412 0 26.0014C0 26.1621 0.00277171 26.3229 0.00554341 26.4837C0.263312 12.3452 11.8019 0.964554 26.0014 0.964554Z",
    fill: "#E07777"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.0014 46.9694C17.2871 46.9694 9.63444 42.4321 5.27177 35.5943C4.30167 34.0754 3.53946 34.3831 4.17418 36.0877C7.47251 44.9405 16.0011 51.2462 26.0041 51.2462C36.0072 51.2462 44.7048 44.813 47.9311 35.8216C48.5132 34.1974 47.8979 33.6791 47.0802 35.04C42.7841 42.191 34.954 46.975 26.0041 46.975L26.0014 46.9694Z",
    fill: "#DC1010"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M41.2539 16.7524C40.5277 16.7524 39.8182 16.4032 39.383 15.7546C37.9112 13.5566 35.4111 11.913 34.3995 11.5222C33.2409 11.0732 32.6644 9.77327 33.1134 8.61469C33.5624 7.45612 34.8651 6.87961 36.0209 7.32862C38.0692 8.12133 41.2539 10.4662 43.122 13.2545C43.8122 14.2856 43.5378 15.6825 42.5039 16.3755C42.1187 16.6332 41.6835 16.7552 41.2539 16.7552V16.7524ZM29.5074 4.96436C28.2324 4.96436 27.1958 5.9982 27.1958 7.27596C27.1958 8.55372 28.2296 9.58756 29.5074 9.58756C30.7852 9.58756 31.819 8.55372 31.819 7.27596C31.819 5.9982 30.7852 4.96436 29.5074 4.96436Z",
    fill: "url(#paint2_linear_13_24250)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6475 13.5923C32.3315 12.9088 33.4121 12.8668 34.1436 13.4644L34.2852 13.5923L38.1523 17.4604V17.4595C38.8346 18.1429 38.8768 19.2255 38.2803 19.9575L38.1523 20.0991L33.3262 24.9282L32.9736 25.2817L33.3262 25.6353L38.1523 30.4663C38.8358 31.1482 38.8779 32.2298 38.2803 32.9634L38.1523 33.105L34.2852 36.9731C33.6033 37.6557 32.5227 37.6984 31.791 37.1011L31.6494 36.9731L26.8213 32.1431L26.4678 31.7896L26.1143 32.1431L21.2871 36.9731C20.6032 37.656 19.523 37.6982 18.791 37.1011L18.6494 36.9731L14.7832 33.105C14.1002 32.4225 14.0568 31.3405 14.6543 30.6079L14.7832 30.4663L19.6104 25.6353L19.9639 25.2817L19.6104 24.9282L14.7832 20.0981L14.6543 19.9565C14.0968 19.2731 14.0969 18.2861 14.6543 17.603L14.7832 17.4614L18.6494 13.5933C19.3769 12.8642 20.5577 12.8626 21.2871 13.5903V13.5913L26.1143 18.4214L26.4678 18.7759L26.8213 18.4214L31.6475 13.5923Z",
    fill: "white",
    stroke: "#EA2F2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_24250",
    x1: -10.771,
    y1: 26.0015,
    x2: 62.772,
    y2: 26.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD371F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_24250",
    x1: 26.0001,
    y1: 49.4136,
    x2: 26.0001,
    y2: 2.58557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_24250",
    x1: 27.6753,
    y1: 5.82358,
    x2: 43.5655,
    y2: 14.9979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_24250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClosePopup);
export default __webpack_public_path__ + "static/media/icon-close-popup.e86163840bbaf95a4584573dcc8fd3d9.svg";
export { ForwardRef as ReactComponent };